<template>
    <v-flex xs12 md12 px-2 text-xs-center blockto-notify>
        <h2 class="flex xs12  md8 px-2 font--light _text-results text-xs-center d-inline-block">
            <span class="">To hire one of these NannieGrannies:</span>
        </h2>
        <v-btn :ripple="false"
                class="xs12 md4 px-2 ma-0 primary v-btn--default elevation-0"
                :value="false"
                @click.stop.prevent="signuppage">
            Sign up now
        </v-btn>
    </v-flex>
</template>

<script>
  import AppBtnTogglePlan from '../app-buttons/app-btn-toggle-plan'

  export default {
    name: 'app-card-subscription',
    components: {AppBtnTogglePlan},
    methods: {
      signuppage () {
        this.$router.push('signup')
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .blockto-notify
        background-color var(--green)
        color #fff
        padding 45px 0 !important

    .app-bg-sand 
        margin 0 -16px !important
    .subscription-layout
        position relative
        padding: 0 !important;
        z-index 1
        @media (max-width 959px)
            overflow hidden
        &--bg-elements
            .svg-icon
                position absolute
                &._pattern-09
                    width 170px
                    height 240px
                    @media (min-width 600px)
                        display none
                    @media (min-width 960px)
                        display block
                        left -125px
                        top -225px
                &._pattern-15
                    width 170px
                    height 240px
                    transform rotate(0deg)
                    z-index 1
                    @media (min-width 600px)
                        display none
                    @media (min-width 960px)
                        display block
                        top -105px
                        left 1135px

    ._box
       
        position relative
        padding 8px 16px !important
        z-index 2
        @media (max-width 959px)
            overflow hidden
            padding 8px 8px !important
    .container
        background-color var(--green)
        padding 0 16px
    ._sub_left_block
        width 22%
        float left
        @media (max-width 959px)
            display block
            width 100%
            margin 0 !important;
    ._sub_right_block
        width 79%
        float left
        @media (max-width 959px)
            width 100%
            margin: 0;
    ._title
        color var(--black);
        margin 20px 15px 0px 0px
        font-size 18px
        text-align left
        @media (max-width 959px)
            font-size 12px
            text-align center
            font-weight: normal;
            margin: 20px 0px 0 0;            
    ._title > a
        @media (max-width 959px)
            font-weight: normal;
            margin-top 20px
    ._actions
        margin 16px 0 100px
    ._creative
        position absolute
        bottom 24px
        left 16px
        width 70px
        height 70px
        color var(--orange)

    @media (min-width: 600px)
        ._title
            margin 20px 15px 0px 0px
            font-size 18px
        ._actions
            margin 16px 0
        ._creative
            bottom: 45px
            left: 45px
        .v-btn--default
            margin-top: 45px;
            margin-left: 0px;
            min-width: 195px
            font-size: 1em;
    @media (min-width: 768px)
        ._creative
            width 98px
            height 98px
            bottom: 45px
            left: 70px
</style>



// WEBPACK FOOTER //
// src/components/app-card/app-card-subscription.vue